import {
  FINANCIAL_SNAPSHOT_EXTRACT_INFO_KEYS,
  QCF_NARRATIVE_FIELD_KEYS,
  isSnapshotTableMetricKey,
} from './financialSnapshotFieldOrder';

export const SNAPSHOT_COHORT_CLEAR_KEYS = ['qcfCohortSheet', 'cohortData'];

const SNAPSHOT_FINANCE_META_CLEAR_KEYS = [
  ...FINANCIAL_SNAPSHOT_EXTRACT_INFO_KEYS,
  ...QCF_NARRATIVE_FIELD_KEYS,
  'qcfSkippedFiles',
];

function selectedFilesList(snapshot) {
  const files = snapshot?.qcfSelectedFiles;
  if (Array.isArray(files)) {
    return files;
  }
  if (Array.isArray(files?.value)) {
    return files.value;
  }
  return [];
}

function fileRole(file) {
  return String(file?.role || '').trim().toLowerCase();
}

export function snapshotHasFinanceData(snapshot) {
  if (!snapshot) {
    return false;
  }
  return Object.keys(snapshot).some((key) => isSnapshotTableMetricKey(key) && snapshot[key] != null);
}

export function snapshotHasCohortData(snapshot) {
  if (!snapshot) {
    return false;
  }
  const sheet = snapshot.qcfCohortSheet;
  const value = sheet && typeof sheet === 'object' && 'value' in sheet ? sheet.value : sheet;
  if (value?.cohorts?.length) {
    return true;
  }
  return snapshot.cohortData != null;
}

export function clearSnapshotFinance(snapshot) {
  if (!snapshot) {
    return snapshot;
  }
  const next = { ...snapshot };
  Object.keys(next).forEach((key) => {
    if (isSnapshotTableMetricKey(key)) {
      delete next[key];
    }
  });
  SNAPSHOT_FINANCE_META_CLEAR_KEYS.forEach((key) => {
    delete next[key];
  });
  next.qcfSelectedFiles = selectedFilesList(snapshot).filter((file) => fileRole(file) === 'cohort');
  return next;
}

export function clearSnapshotCohort(snapshot) {
  if (!snapshot) {
    return snapshot;
  }
  const next = { ...snapshot };
  SNAPSHOT_COHORT_CLEAR_KEYS.forEach((key) => {
    delete next[key];
  });
  delete next.qcfRunoff;
  delete next.qcfLiquidValue;
  next.qcfSelectedFiles = selectedFilesList(snapshot).filter((file) => fileRole(file) !== 'cohort');
  return next;
}
